// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Dealer } from './dealer';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ShipAddress extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get displayName() {
    return [this.location, this.address1].filter(x => x).join(' - ');
}
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  address1?: string;
  address2?: string;
  city?: string;
  contactName?: string;
  country?: string;
  dealerId!: number;
  email?: string;
  fax?: string;
  loadedMiles!: number;
  location?: string;
  notes?: string;
  phone1?: string;
  phone2?: string;
  state?: string;
  zip?: string;
  dealer!: Dealer;
}

